module.exports = __webpack_public_path__ + "img/Deleted.65ac90b9.svg";